// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.shopfields[data-v-f2756f2c]{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1em;\n}\n.shopfields .inputfield[data-v-f2756f2c]{\n  width: 48%;\n}\n@media only screen and (max-width: 540px) {\n.shopfields[data-v-f2756f2c] {\n    flex-direction: column;\n    width: 100%;\n}\n.shopfields .inputfield[data-v-f2756f2c]{\n    width: 100%;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
